import { useContext, useEffect, useState } from "react";
import { FiHeart, FiShoppingBag } from "react-icons/fi";
import { Link } from "react-router-dom";
import { productImageSrcSet } from "../utils/images";
import { CartContext } from "./CartContext";

const money = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

function ProductCard({ product, tone = "cream", priority = false }) {
  const { addToCart, toggleWishlist, isInWishlist } = useContext(CartContext);
  const [added, setAdded] = useState(false);
  const wished = isInWishlist(product.id);
  const inStock = !Number.isFinite(Number(product.stock)) || Number(product.stock) > 0;

  useEffect(() => {
    if (!added) return undefined;
    const timer = window.setTimeout(() => setAdded(false), 1400);
    return () => window.clearTimeout(timer);
  }, [added]);

  const addProduct = () => {
    if (!inStock) return;
    addToCart(product.id, 1);
    setAdded(true);
  };

  return (
    <article className={`product-card product-card--${tone}`}>
      <div className="product-card__visual">
        <Link to={`/product/${product.slug}`} aria-label={`View ${product.name}`}>
          <img
            src={product.images[0]}
            srcSet={productImageSrcSet(product.images[0])}
            sizes="(max-width: 600px) 50vw, (max-width: 1000px) 33vw, 25vw"
            alt={product.name}
            width="1200"
            height="1200"
            loading={priority ? "eager" : "lazy"}
            decoding="async"
          />
        </Link>
        <button
          className={`product-card__wish ${wished ? "is-active" : ""}`}
          type="button"
          aria-label={wished ? `Remove ${product.name} from favorites` : `Save ${product.name}`}
          aria-pressed={wished}
          onClick={() => toggleWishlist(product.id)}
        >
          <FiHeart aria-hidden="true" />
        </button>
        {(product.newArrival || product.bestseller) && (
          <span className="product-card__badge">
            {product.newArrival ? "New harvest" : "Bestseller"}
          </span>
        )}
      </div>

      <div className="product-card__body">
        <Link className="product-card__category" to={`/shop?category=${encodeURIComponent(product.category)}`}>
          {product.category}
        </Link>
        <Link className="product-card__title" to={`/product/${product.slug}`}>
          {product.name}
        </Link>
        <p className="product-card__unit">{product.unit}</p>
        <div className="product-card__foot">
          <div className="product-card__price">
            <span>{money.format(product.price)}</span>
            {product.compareAtPrice && (
              <del>{money.format(product.compareAtPrice)}</del>
            )}
          </div>
          <button
            className={`product-card__add ${added ? "is-added" : ""}`}
            type="button"
            onClick={addProduct}
            aria-live="polite"
            disabled={!inStock}
          >
            <FiShoppingBag aria-hidden="true" />
            {!inStock ? "Sold out" : added ? "Added" : "+ Cart"}
          </button>
        </div>
      </div>
    </article>
  );
}

export { money };
export default ProductCard;
